import * as React from 'react';
import { ReviewDisplay } from '@grandvisionhq/reviews';
import { useFeatureToggles } from '@grandvisionhq/state';
import '../../context/actions.js';
import '../../context/reducer.js';
import { useProductData } from '../../context/product-context-hooks.js';
import '../../context/ProductContext.js';
import '../../context/CmsContext.js';
import { getReviewsConfigKeys } from './utils/get-reviews-config-keys.js';

const UserReviews = ({ isSingleColumn  })=>{
    const { isReviewsEnabled  } = useFeatureToggles();
    const { product , activeVariant: { sku  } ,  } = useProductData();
    if (!isReviewsEnabled) {
        return null;
    }
    const { productId , variantId  } = getReviewsConfigKeys(product, sku);
    return /*#__PURE__*/ React.createElement(ReviewDisplay, {
        productId: productId,
        variantId: variantId,
        isSingleColumn: isSingleColumn
    });
};

export { UserReviews };
//# sourceMappingURL=UserReviews.js.map
